module.exports = {
  "wxc-slider-bar": {
    "userSelect": "none"
  },
  "slider-bar-container": {
    "height": 56,
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "value-bar": {
    "height": 4
  },
  "slide-block": {
    "width": 56,
    "height": 56,
    "backgroundColor": "#ffffff",
    "borderRadius": 28,
    "borderWidth": 1,
    "borderColor": "rgba(0,0,0,0.1)",
    "boxShadow": "0 6px 12px rgba(0, 0, 0, 0.05)",
    "position": "absolute",
    "left": 0,
    "bottom": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-18021479!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-slider-bar/index.vue
// module id = 185
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28